var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLotAngle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.61091 1.61092H9.38909V9.38909H1.61091V1.61092Z",
    fill: "#0039A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0L11 5.5L5.5 11L0 5.5L5.5 0Z",
    fill: "#0039A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLotAngle);
export default __webpack_public_path__ + "static/media/LotAngle.59729aafba6e356c86d858920f9ae0d2.svg";
export { ForwardRef as ReactComponent };